export default __webpack_public_path__ + "static/media/hellogreen.e49247c0.svg";